export const EnergyTypeCode = {
    /** 電気*/
    denki: '3',
    /** LPガス */
    lpGas: '2',
    /** 都市ガス */
    toshiGas: '1',
} as const;